import React from "react";
import "../../App.css";

const LabelNode = ({ data }) => {
  const { label, totalCount, malesCount, femalesCount, inLawsCount, hasYellowBackground, mainMemberName, mainMemberGender, spouseName, spouseNameGender, generation } = data;

  // Handle root member names label
  if (label === 'rootMemberNames') {
    // ===== COMMENTED OUT: Previous implementation with colored text =====
    // const nameParts = [];
    // 
    // // Great Vibes font family for fancy styling
    // const scriptFontFamily = '"Great Vibes", cursive';
    // 
    // // Add main member name with appropriate color - larger font for main heading
    // if (mainMemberName) {
    //   const mainColor = mainMemberGender === 1 ? '#0000FF' : '#FF0000'; // Blue for male, red for female
    //   nameParts.push(
    //     <span key="main" style={{ color: mainColor, fontWeight: 'bold', fontSize: '200px', lineHeight: '1', fontFamily: scriptFontFamily }}>
    //       {mainMemberName}
    //     </span>
    //   );
    // }
    // 
    // // Add spouse name with appropriate color and separator - larger font for main heading
    // if (spouseName) {
    //   if (mainMemberName) {
    //     nameParts.push(
    //       <span key="separator" style={{ fontSize: '200px', lineHeight: '1', margin: '0 40px', fontWeight: 'bold', fontFamily: scriptFontFamily }}>
    //         &
    //       </span>
    //     );
    //   }
    //   const spouseColor = spouseNameGender === 1 ? '#0000FF' : '#FF0000'; // Blue for male, red for female
    //   nameParts.push(
    //     <span key="spouse" style={{ color: spouseColor, fontWeight: 'bold', fontSize: '200px', lineHeight: '1', fontFamily: scriptFontFamily }}>
    //       {spouseName}
    //     </span>
    //   );
    // }
    // 
    // // Add "Family" on the same line with a space before it
    // nameParts.push(
    //   <span key="space" style={{ fontSize: '200px', lineHeight: '1' }}>
    //     {' '}
    //   </span>
    // );
    // nameParts.push(
    //   <span key="family" style={{ 
    //     fontSize: '200px', 
    //     fontWeight: 'bold', 
    //     lineHeight: '1',
    //     color: '#333',
    //     fontFamily: scriptFontFamily
    //   }}>
    //     Family
    //   </span>
    // );
    // 
    // return (
    //   <div className="generation-label-node" style={{ 
    //     width: '100%',
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center'
    //   }}>
    //     <div style={{ 
    //       display: 'flex', 
    //       flexDirection: 'row', 
    //       alignItems: 'center', 
    //       justifyContent: 'center',
    //       lineHeight: '1',
    //       width: '100%'
    //     }}>
    //       {nameParts}
    //     </div>
    //   </div>
    // );

    // Root banner: Georgia Pro Black, 16px (match header family line)
    const nameParts = [];
    const rootTitleColor = '#025FEB';
    const rootTitleFont =
      '"Georgia Pro", "Georgia Pro Black", Georgia, "Times New Roman", serif';
    const rootTitleSize = '16px';
    const rootTitleWeight = 700;
    const rootTitleShadow = '0.4px 0 0 currentColor, -0.4px 0 0 currentColor';
    const rootSpanBase = {
      color: rootTitleColor,
      fontFamily: rootTitleFont,
      fontSize: rootTitleSize,
      lineHeight: '1.1',
      fontWeight: rootTitleWeight,
      textShadow: rootTitleShadow,
    };

    if (mainMemberName) {
      nameParts.push(
        <span key="main" style={rootSpanBase}>
          {mainMemberName}
        </span>
      );
    }

    if (spouseName) {
      if (mainMemberName) {
        nameParts.push(
          <span key="separator" style={{ ...rootSpanBase, margin: '0 40px' }}>
            &nbsp;&&nbsp;
          </span>
        );
      }
      nameParts.push(
        <span key="spouse" style={rootSpanBase}>
          {spouseName}
        </span>
      );
    }

    nameParts.push(
      <span key="space" style={{ fontSize: rootTitleSize, lineHeight: '1.1', color: rootTitleColor, textShadow: rootTitleShadow }}>
        {' '}
      </span>
    );
    nameParts.push(
      <span key="family" style={{
        ...rootSpanBase,
      }}>
       &nbsp;&nbsp;Family
      </span>
    );

    return (
      <div className="generation-label-node" style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'transparent',
        padding: '20px 40px',
        borderRadius: 0
      }}>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row', 
          alignItems: 'center', 
          justifyContent: 'center',
          lineHeight: '1',
          width: '100%'
        }}>
          {nameParts}
        </div>
      </div>
    );
  }

  const maleLabel = generation === 1 ? 'Male' : 'Male(s)';
  const femaleLabel = generation === 1 ? 'Female' : 'Female(s)';

  const isYellowBannerOnly = Boolean(hasYellowBackground && totalCount === undefined);

  return (
    <div
      className={
        isYellowBannerOnly
          ? 'generation-label-node generation-label-node--yellow-banner'
          : 'generation-label-node'
      }
      style={{
        width: '100%',
        justifyContent: 'flex-start',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          lineHeight: '1',
          width: '100%',
          boxSizing: 'border-box',
          textAlign: 'left',
          backgroundColor: hasYellowBackground ? '#FFEB3B' : 'transparent',
          /* Match Gen rows: no horizontal inset so text lines up with Gen 1 / Gen 2 blocks */
          padding: hasYellowBackground ? '4px 0' : '0',
          borderRadius: hasYellowBackground ? '4px' : '0',
        }}
      >
        <span style={{ fontWeight: 'bold', fontSize: '38px', lineHeight: '1' }}>
          {label} {totalCount !== undefined && <span style={{ fontWeight: 900, fontSize: '38px' }}>({totalCount})</span>}
        </span>
        {totalCount !== undefined && (
          <>
            <span style={{ fontSize: '28px', color: '#333', marginTop: '0px', lineHeight: '1' }}>
              ({malesCount}) <span style={{ color: '#0000FF', fontWeight: 900 }}>{maleLabel}</span>, ({femalesCount}) <span style={{ color: '#FF0000', fontWeight: 900 }}>{femaleLabel}</span>
            </span>
            {Number(generation) !== 1 && (
              <span style={{ fontSize: '28px', color: '#333', display: 'block', marginTop: '0px', lineHeight: '1' }}>
                ({inLawsCount ?? 0}) In-Law(s)
              </span>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default LabelNode;

